import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-input-box-mobile" }
const _hoisted_2 = { class: "form-input-line" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "validator-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelMobile = _resolveComponent("LabelMobile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LabelMobile, {
      name: $props.name,
      "is-required": $props.isRequired
    }, null, 8, ["name", "is-required"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "form-input-mobile",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.text) = $event)),
        placeholder: $props.placeholder,
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onInputChanged && $setup.onInputChanged(...args)))
      }, null, 40, _hoisted_3), [
        [_vModelText, $setup.text]
      ]),
      ($props.validator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.TUITranslateService.t("AIDesk.请填写必填项")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}